import { UnitStatusSearchForm } from '@mark43/cad-api';
import { FilterSummary } from '../search-windows/filter-summary';
import { FiltersSummary } from '../search-windows/filters-summary';

export function OtherFiltersSummary({ form }: { form: UnitStatusSearchForm }) {
    return (
        <FiltersSummary title="Other">
            <FilterSummary
                label="Enable Fuzzy Matching"
                key="Enable Fuzzy Matching"
                booleanValue={form.fuzzyMatchingEnabled}
            />
        </FiltersSummary>
    );
}
